import { TableHead, TableRow, TableCell, Checkbox, Box, IconButton, Menu, MenuItem } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import SortingIcon from '../../../../components/SortingIcon'

const TableHeader = ({
  sortConfig,
  handleSortChange,
  isHeaderCheckboxChecked,
  paginatedPages,
  setCheckedPages,
  setIsHeaderCheckboxChecked,
  anchorEl,
  open,
  handleClickCheckAllDropdown,
  handleCloseCheckAllDropdown,
  handleCheckAllPages,
  handleUncheckAllPages
}) => {

  const handleHeaderCheckboxChange = (e) => {
    const allChecked = e.target.checked
    const currentPageIds = paginatedPages.map(page => page.id)

    setCheckedPages(prevCheckedPages => {
      if (allChecked) {
        return [...new Set([...prevCheckedPages, ...currentPageIds])]
      } else {
        return prevCheckedPages.filter(id => !currentPageIds.includes(id))
      }
    })

    setIsHeaderCheckboxChecked(allChecked)
  }

  return (
    <TableHead className='pagesTableHeader'>
      <TableRow>
        <TableCell className='pagesTableHeaderCheckboxCell'>
          <Checkbox
            className='pagesTableHeaderCheckbox'
            checked={isHeaderCheckboxChecked}
            onChange={handleHeaderCheckboxChange}
          />
          <IconButton
            onClick={handleClickCheckAllDropdown}
            size="small"
            sx={{ p: 0 }}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleCloseCheckAllDropdown}
          >
            <MenuItem onClick={handleCheckAllPages} sx={{ minWidth: '100px' }}>All</MenuItem>
            <MenuItem onClick={handleUncheckAllPages}>None</MenuItem>
          </Menu>
        </TableCell>
        <TableCell className='pagesTableHeaderCell pageName' onClick={() => handleSortChange('label')}>
          <Box className="pagesTableHeaderCellContent">
            <SortingIcon sortConfig={sortConfig} currentKey={'label'}/>
            Page
          </Box>
        </TableCell>
        <TableCell className='pagesTableHeaderCell pageUrl' onClick={() => handleSortChange('url')}>
          <Box className="pagesTableHeaderCellContent">
            <SortingIcon sortConfig={sortConfig} currentKey={'url'}/>
            URL
          </Box>
        </TableCell>
        <TableCell className='pagesTableHeaderCell pageDate' onClick={() => handleSortChange('created_at')}>
          <Box className="pagesTableHeaderCellContent">
            <SortingIcon sortConfig={sortConfig} currentKey={'created_at'}/>
            Last Discovery Date
          </Box>
        </TableCell>
        <TableCell className='pagesTableHeaderCell pageDate' onClick={() => handleSortChange('last_scanned_at')}>
          <Box className="pagesTableHeaderCellContent">
            <SortingIcon sortConfig={sortConfig} currentKey={'last_scanned_at'}/>
            Last Scan Date
          </Box>
        </TableCell>
        <TableCell className='pagesTableHeaderCell pageTests' onClick={() => handleSortChange('passed_ui_test_count')}>
          <Box className="pagesTableHeaderCellContent">
            <SortingIcon sortConfig={sortConfig} currentKey={'passed_ui_test_count'}/>
            UI Tests
          </Box>
        </TableCell>
        <TableCell className='pagesTableHeaderCell pageTestCases' onClick={() => handleSortChange('testCasesTotal')}>
          <Box className="pagesTableHeaderCellContent">
            <SortingIcon sortConfig={sortConfig} currentKey={'testCasesTotal'}/>
            Test Cases
          </Box>
        </TableCell>
        <TableCell />
      </TableRow>
    </TableHead>
  )
}

export default TableHeader